import { useSelector } from 'react-redux'
import { URLS } from '../const/nav'
import { authFetch } from '../services/authFetch'

// TODO: Refactorizar para poder reusarlo con multiples urls
// Este hook sólo permite abrir un PDF por instancia
// y sólo se puede declarar una instancia por función.
export const useOpenPDF = (url) => {
  const { user } = useSelector(state => state)

  const openPDF = async (_url) => {
    try {
      const response = await authFetch(`${URLS.BACKEND_URL}/${_url || url}/`, {
        method: 'GET',
        headers: {
          Authorization: `${user.token}`
        }
      })

      if (response.status === 404) {
        // Manejar error 404 (No encontrado)
      } else if (response.ok) {
        const blob = await response.blob()
        const pdfUrl = window.URL.createObjectURL(blob)
        window.open(pdfUrl, '_blank') // Abre el PDF en una nueva pestaña
      } else {
        // Manejar otros errores
        console.error(`Error en la solicitud: ${response.status}`)
      }
    } catch (error) {
      console.error('Error al realizar la solicitud:', error)
    }
  }

  return { openPDF }
}
